export default "__VITE_PUBLIC_ASSET__dffeee9a__"